import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import ListFaqs from "app/pages/FAQs";

const routesName = "/dashboards/faqs";

export const faqRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListFaqs} />,
      },
    ],
  },
];
